<template>
    <div v-if="bodyShow" class="main">
        <h2>以下为学员个人资料信息,您可添加学员微信组建小组群<span>(可左右滑动表格查看学员整体信息)</span></h2>
        <div v-if="list.length>0" class="table-box">
            <table cellSpacing="0" cellPadding="0">
                <thead>
                    <tr>
                        <th>姓名</th>
                        <th>性别</th>
                        <th>手机号</th>
                        <th>微信号</th>
                        <th class="active">风格标签</th>
                        <th>工作年限</th>
                        <th>目前从事的行业</th>
                        <th>目前的岗位</th>
                        <th>职级</th>
                        <!-- <th>想往哪方面转型</th> -->
                        <th class="active">成就事件</th>
                        <th>项目期待</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in list" :key="index">
                        <td>{{item.name}}</td>
                        <td>{{item.sex}}</td>
                        <td>{{item.mobile}}</td>
                        <td>{{item.wechat}}</td>
                        <td class="active"><div>{{item.styletags}}</div></td>
                        <td>{{item.workage}}</td>
                        <td>{{item.career}}</td>
                        <td>{{item.job}}</td>
                        <td>{{item.job_grade}}</td>
                        <!-- <td>{{item.other}}</td> -->
                        <td width="300" class="active"><div>{{item.achievethings}}</div></td>
                        <td>{{item.project_forward}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {TutorGroupList} from '@/api/assistant'
import { shareCon } from "@/utils/wxconfig";
export default {
    data() {
        return{
            bodyShow:false,
            list:[]
        }
    },
    methods:{
        pullData(){
            TutorGroupList({
                cid:this.$route.query.cid
            }).then((data)=>{
                if(data.code===10002){
                    this.$toast(data.data.msg);
                    return;
                }
                this.list = data;
                this.bodyShow = true;
            });
        }
    },
    created(){
        this.pullData();
        shareCon("course",this);
    }
}
</script>
<style lang="scss" scoped>
.main{
    padding: 30px;
    h2{
        font-size: 32px;
        color: #333333;
        margin-bottom: 45px;
        span{
            font-size: 24px;
            color: #999999;
        }
    }
    .table-box{
        overflow-x: auto;
        background-color: #ffffff;
        table{
            border-collapse: collapse;
            border: 0;
            th{
                border: 1px solid #EB5032;
                white-space:nowrap;
                padding: 18px 0;
            }
            td{
                border: 1px solid #EB5032;
                padding: 18px 44px;
            }
            .active{
                div{
                    width: 300px;
                }
            }
        }
    }
}
</style>

